import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

const ModifySfReceipt = () => {
   useAuthRedirect();
    const {sfNo} = useParams();
  const branch = localStorage.getItem("branch");
  const userId = localStorage.getItem("username");
  const [indentView, setIndentView] = useState({dept: "", remarks: "", hod: "", hm: "" });
  const [data, setData] = useState([]);
const navigate = useNavigate();

  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        Swal.fire({
                          title: "Fetching Receipt Details",
                          html: `
                            <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                              <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
                            </div>
                            <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch Receipt Details...</p>
                          `,
                          showConfirmButton: false,
                          allowOutsideClick: false,
                          didOpen: () => {
                            const style = document.createElement("style");
                            style.innerHTML = `
                              @keyframes progressBar {
                                0% { width: 0% }
                                50% { width: 100% }
                                100% { width: 0% }
                              }
                            `;
                            document.head.appendChild(style);
                          },
                        });
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/sfReceiptModify_detailsHeader?sfNo=${sfNo}&branch=${branch}`);
        if (response.data && response.data.headerDetails?.length > 0) {
            const items = response.data.headerDetails;

            const storeReqHeader = {
                sfNo: items[0].sfReceiptsHeader_number,
                date: items[0].sfReceiptsHeader_date,
                indentRef: items[0].sfReceiptsHeader_indentReferenceNumber,
                remarks: items[0].sfReceiptsHeader_remarks,
            };

            setIndentView(storeReqHeader);
        }
        Swal.close();
      } catch (error) {
        Swal.close();
                          console.error("Error fetching Receipt Details. Please try again:", error);
                          Swal.fire({
                            icon: "error",
                            title: "Oops!",
                            text: "Error fetching Receipt Details. Please try again",
                          });
      }
    };

    fetchIndentDetails();
  }, [sfNo, branch]); 

  
useEffect(() => {
    const fetchBottom = async () => {
      try {
        Swal.fire({
                          title: "Fetching Receipt Details",
                          html: `
                            <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                              <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
                            </div>
                            <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch Receipt Details...</p>
                          `,
                          showConfirmButton: false,
                          allowOutsideClick: false,
                          didOpen: () => {
                            const style = document.createElement("style");
                            style.innerHTML = `
                              @keyframes progressBar {
                                0% { width: 0% }
                                50% { width: 100% }
                                100% { width: 0% }
                              }
                            `;
                            document.head.appendChild(style);
                          },
                        });
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/sfReceiptModify_bottomDetails?sfNo=${sfNo}&branch=${branch}`);
        setData(response.data.bottomDetails);
        Swal.close();
      } catch (error) {
        Swal.close();
                          console.error("Error fetching Receipt Details. Please try again:", error);
                          Swal.fire({
                            icon: "error",
                            title: "Oops!",
                            text: "Error fetching Receipt Details. Please try again",
                          });
      }
    };
    fetchBottom();
  }, [sfNo, branch]);


const handleRowChange = (index, field, value) => {
    setData((prevItems) =>
      prevItems.map((item, i) => (i === index ? { ...item, [field]: value } : item))
    );
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setIndentView((prev) => ({ ...prev, [name]: value }));
  };


 

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!indentView.indentRef || indentView.indentRef.toString().trim() === "") {
  Swal.fire("Error", "Ref Number shouldn't be empty", "error");
  return;
}

if (!/^\d+$/.test(indentView.indentRef.toString().trim())) {
  Swal.fire("Error", "Ref Number must be a numeric value", "error");
  return;
}

        
        try {
          const updatedData = {
            sfNo: sfNo,
            branch: branch,
            user : userId,
            remarks: indentView.remarks,
            indentRef: indentView.indentRef,
          };
          console.log(updatedData);
    
          Swal.fire({
                      title: "Submitting...",
                      text: "Please wait while we process your request.",
                      allowOutsideClick: false,
                      didOpen: () => {
                          Swal.showLoading();
                      },
                  });
          
          const response = await axios.put("https://rfs2.infraconsoft.net.in/api/sfReceiptModify_update", updatedData);
          if (response.data.success) {
            // alert("sucess")
            Swal.fire("Success!", "Store Receipt updated successfully!", "success");
            navigate('/inventory/sfReceiptsView');
          } else {
            Swal.fire("Error", "Failed to Branch Store Req", "error");
          }
        } catch (error) {
          console.error("Error updating Branch Store Req:", error);
          Swal.fire("Error", "Server error while updating", "error");
        }
      };
    

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
           <div className="back-div">
                    <h2 className="add-txt">Shop Floor Receipts - Modify</h2>
                    <Link to='/inventory/sfReceiptsView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                    </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
          <div className="form-row">
              <div className="form-group">
                <label>Receipt No :</label>
                <input type="text" name="indentNo" value={indentView.sfNo} readOnly/>
              </div>
              <div className="form-group">
                <label>Date :</label>
                <input
  type="text"
  name="endhrs"
  value={indentView.date ? new Date(indentView.date).toISOString().split("T")[0] : ""}
 readOnly
/>

              </div>
            </div>


            <div className="form-row">
              <div className="form-group">
                <label>Indent Ref No :</label>
                <input type="text" value={indentView.indentRef} name="indentRef" onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Remarks</label>
                <input type="text" value={indentView.remarks} name="remarks" onChange={handleInputChange}  />
              </div>
            </div>


            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Desctiption</th>
                    <th>UOM</th>
                    <th>Received Qty</th>
                    <th>Price</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
  {data.length > 0 ? (
    data.map((item, index) => {
      const value = item.sfReceiptsDetail_receivedQuantity * item.sfReceiptsDetail_price;
      return (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{item.sfReceiptsDetail_itemCode}</td>
          <td>{item.itemmaster_name}</td>
          <td>{item.itemmaster_uom}</td>
          <td>{item.sfReceiptsDetail_receivedQuantity}</td>
          <td>{item.sfReceiptsDetail_price}</td>
          <td>{value}</td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="8">No items</td>
    </tr>
  )}
</tbody>

              </table>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>

    </div>
  );
};

export default ModifySfReceipt;
